import UpdateShopOrderRequestModelBase from '../_generated/modelBases/update-shop-order-request-model-base';

export default class UpdateShopOrderRequestModel extends UpdateShopOrderRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
